import { useEffect, useState } from 'react';
import { fetchCourse, fetchOptionsInformation, setCourseBasicInformation } from 'Api/editCourseInformation';

const useFetch = courseId => {
  const [course, setCourse] = useState({});
  const [categories, setCategories] = useState([]);
  const [terminals, setTerminals] = useState([]);
  const [priorities, setPriorities] = useState([]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchCourse({ id: courseId }).then(data => {
        setCourse(data);
      });
    }

    return () => {
      isMounted = false;
      setCourse({});
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchOptionsInformation().then(data => {
        setCategories(data.categories);
        setTerminals(data.terminals);
        setPriorities(data.priorities);
      });
    }

    return () => {
      isMounted = false;
      setCategories([]);
      setTerminals([]);
      setPriorities([]);
    };
  }, []);

  return {
    course,
    categories,
    terminals,
    priorities,
    setCourseBasicInformation,
  };
};

export default useFetch;
